/* @flow */

import Edit from './Edit';
import View from './View';

export type FlowHeader = {
  title?: string,
  shortTitle?: string,
  image?: CatalogResource,
};

export const getEditComponent = () => Edit;
export const getViewComponent = () => View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/flow/simple/index.js